<template>
  <v-layout column>
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="id"
      :loading="loading"
      :options.sync="options"
      :server-items-length="options.totalItems"
      :items-per-page="5"
    >
      <v-progress-linear slot="progress" indeterminate></v-progress-linear>
      <template v-slot:item.insertTime="{ value }">
        {{ value | dateTimeFilter }}
      </template>
      <template v-slot:item.expirationDate="{ value }">
        {{ value | dateTimeFilter }}
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
import { Header } from "../../common/Common";
import dateTimeFilters from "../../mixins/date-time-filters";
import ReportsService from "../../services/ReportsService.js";
export default {
  name: "ContactQuarantineTable",
  mixins: [dateTimeFilters],
  props: {},
  data() {
    return {
      headers: [
        new Header(this.$t("marketingReport.name"), "firstName", 0),
        new Header(this.$t("marketingReport.surname"), "surname", 0),
        new Header(this.$t("marketingReport.phone"), "phone", 0),
        new Header(this.$t("marketingReport.mail"), "mail", 0),
        new Header(this.$t("marketingReport.desc"), "description", 0),
        new Header(this.$t("marketingReport.system"), "domainSystemName", 0),
        new Header(this.$t("marketingReport.insertDate"), "insertTime", 0),
        new Header(this.$t("marketingReport.insertUser"), "insertUser", 0),
        new Header(
          this.$t("marketingReport.expirationDate"),
          "expirationDate",
          0
        )
      ],
      items: [],
      options: {},
      loading: false
    };
  },
  watch: {
    options() {
      if (this.items.length > 0) {
        this.getData();
      }
    },
    loading() {
      this.$emit("processing", !this.loading);
    }
  },
  methods: {
    getData() {
      this.loading = true;
      ReportsService.GetContactQuarantineReport(
        this.options.page,
        this.options.itemsPerPage
      ).then(response => {
        this.items = response.items;
        this.loading = false;
        this.options.totalItems = response.totalItems;
      });
    }
  }
};
</script>
<style scoped lang="scss"></style>
